const dows = [
  "Domingo",
  "Segunda",
  "Terça",
  "Quarta",
  "Quinta",
  "Sexta",
  "Sábado",
]

export function translateDayOfWeek(dow) {
  return dows[dow] ? dows[dow] : ""
}
